import { getUnformatedValue } from './beneficiaryUtils';
export function isZeroOrEmptyCurrency(value) {
    if (!value)
        return true;
    const numeric = getUnformatedValue(value);
    return !numeric || numeric === 0;
}
export function isZeroOrEmptyDays(value) {
    return value === undefined || value === null || value === 0;
}
